export const environmentClassName = `mt-[48px] w-[360px]`

export const textFieldContainerClassName = 'mt-24px'

export const updateButtonClassName = 'flex items-center justify-center'
